var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "small-12 medium-12", class: _vm.signatureZoneClass },
    _vm._l(_vm.internalValue, function (name, index) {
      return _c(
        "div",
        { key: index, staticClass: "row" },
        [
          _c("SignatureField", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.editStatus,
                expression: "!editStatus",
              },
            ],
            ref: "signatureRefs",
            refInFor: true,
            staticClass: "signature-box pointer columns small-6",
            attrs: { isEditable: !_vm.editStatus, message: _vm.proxySignMsg },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _vm.editStatus
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "small-8" },
                    [
                      _c("HKLInput", {
                        attrs: { value: name },
                        on: {
                          change: function (val) {
                            return _vm.update(val, index)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  index === 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "underline pointer signature__add small-1",
                          on: { click: _vm.add },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("action.add")) +
                              " +\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "small-1" },
                    [
                      index !== 0
                        ? _c("HKLDeleteIcon", {
                            staticClass: "signature__del",
                            on: {
                              click: function ($event) {
                                return _vm.del(index)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : _c("div", { class: _vm.signatureNameClass }, [
                  _vm._v("\n        " + _vm._s(name) + "\n      "),
                ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "signature__zone-text", class: _vm.hintClass },
              [_vm._v(_vm._s(_vm.$t("hotb.signatures.nameInBlockLetter")))]
            ),
          ]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }